// extracted by mini-css-extract-plugin
export var alertIcon = "_nc-0";